import parse from 'url-parse'

export const getQuery = () => parse(location.href, true).query

/**
 * history replaceState 包装方法
 * @param {Object} option  待修改的对象，如果key/value中 value 为 null 或 undefined 或 '', 则删除 key
 */
export const replaceState = (option = {}) => {
  const parsedUrl = parse(location.href, true)
  // 参数为 option 对象
  for (const key in option) {
    const value = option[key]
    if (value || value === 0) {
      parsedUrl.query[key] = value
    } else {
      delete parsedUrl.query[key]
    }
  }
  history.replaceState(null, document.title, parsedUrl.toString())
}
